var e = ((e2) => (e2.Create = "Create", e2.Preview = "Preview", e2.Edit = "Edit", e2))(e || {});
export {
  e as DialogType
};
//# sourceMappingURL=types.js.map
